import React from "react";
import { Checklist as UIChecklist } from "../../../components/ui";

/**
 * Worker timesheet checklist: requirements before submitting weekly timesheet.
 * Uses generic Checklist from ui with timesheet-specific conditions.
 *
 * @param {Object} props Component props.
 * @param {string} [props.className] Extra wrapper classes.
 * @param {boolean} props.shifts Whether shifts have been clocked.
 * @param {boolean} props.signed Whether the timesheet is signed.
 * @param {boolean} props.saved Whether edits have been saved.
 * @param {boolean} props.safetyMeetingReviewed Whether the safety meeting was reviewed.
 * @returns {JSX.Element}
 */
const Checklist = ({ className, shifts, signed, saved, safetyMeetingReviewed }) => {
  const conditions = [
    { met: shifts, message: "Please clock in for your shifts before submitting your timesheet." },
    { met: saved, message: "Please save your changes before submitting." },
    { met: safetyMeetingReviewed, message: "Please review the safety meeting before submitting." },
    { met: signed, message: "Please sign your timesheet before submitting." },
  ];

  return (
    <UIChecklist
      className={className}
      conditions={conditions}
      successMessage="All requirements met! You can submit your timesheet."
    />
  );
};

export default Checklist;
